export default "/images/vendor/flag-icon-css/flags/1x1/pg.svg?eb9cc6c51c5a51ef15f403ff9591d448";